import {useContext} from 'react'
import {useTranslation} from 'react-i18next'

import {
  UrlInputRow,
  UrlLink,
  UrlInputWrapper,
  CopyButton,
} from './PublicServiceUrlModal.styled'

import {
  NotificationContext,
  NotificationType,
} from '~/components/notifications/NotificationContext'
import {Icon} from '~/components/general/icon/Icon'
import {theme} from '~/styles/theme'

type CopyableUrlInputProps = {
  url: string
}

export const CopyableUrlInput = ({url}: CopyableUrlInputProps) => {
  const {t} = useTranslation()
  const {addNotification} = useContext(NotificationContext)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url)
      addNotification(t('Copied to clipboard'), NotificationType.Success)
    } catch {
      addNotification(t('Failed to copy to clipboard.'), NotificationType.Error)
    }
  }

  if (!url) return null

  return (
    <UrlInputRow>
      <UrlLink href={url} target="_blank" rel="noopener noreferrer">
        <UrlInputWrapper size="normal">{url}</UrlInputWrapper>
      </UrlLink>
      <CopyButton onClick={handleCopy} title={t('Copy URL to clipboard')}>
        <Icon name="Copy" size="md" color={theme.colors.grey.grey300} />
      </CopyButton>
    </UrlInputRow>
  )
}
